import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout.tsx';
import Dashboard from './components/Dashboard.tsx';
import QuickGenerate from './components/QuickGenerate.tsx';
import AssetLibrary from './components/AssetLibrary.tsx';
import VideoStudio from './components/VideoStudio.tsx';
import CaptionVault from './components/CaptionVault.tsx';
import Campaigns from './components/Campaigns.tsx';
import NarrativeHub from './components/NarrativeHub.tsx';
import ChipDNAProfile from './components/ChipDNAProfile.tsx';
import Settings from './components/Settings.tsx';
import Onboarding from './components/Onboarding.tsx';
import TalkToChip from './components/TalkToChip.tsx';
import Login from './components/Login.tsx';
import { StoreProvider } from './context/StoreContext.tsx';
import { AuthProvider, useAuth } from './context/AuthContext.tsx';
import { ThemeProvider } from './context/ThemeContext.tsx';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center bg-[var(--bg-primary)] text-[var(--text-primary)]">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const AppRoutes: React.FC = () => {
  const { user } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/chip-dna" element={<ProtectedRoute><Layout><ChipDNAProfile /></Layout></ProtectedRoute>} />
      <Route path="/generate" element={<ProtectedRoute><Layout><QuickGenerate /></Layout></ProtectedRoute>} />
      <Route path="/library" element={<ProtectedRoute><Layout><AssetLibrary /></Layout></ProtectedRoute>} />
      <Route path="/video" element={<ProtectedRoute><Layout><VideoStudio /></Layout></ProtectedRoute>} />
      <Route path="/captions" element={<ProtectedRoute><Layout><CaptionVault /></Layout></ProtectedRoute>} />
      <Route path="/campaigns" element={<ProtectedRoute><Layout><Campaigns /></Layout></ProtectedRoute>} />
      <Route path="/narrative" element={<ProtectedRoute><Layout><NarrativeHub /></Layout></ProtectedRoute>} />
      <Route path="/talk" element={<ProtectedRoute><Layout><TalkToChip /></Layout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <StoreProvider>
          <Router>
            <AppRoutes />
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          </Router>
        </StoreProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;